export default __webpack_public_path__ + "static/media/login-bgc.a3e4fe26.jpg";